import React from "react";
import store from "../assets/store.png";
import amazon from "../assets/Screenshot (129).png";
import weather from "../assets/Screenshot (130).png";
import todos from "../assets/todos.png";
import recipe from '../assets/recipe.png'
import movie from "../assets/movies.png";
import jokes from "../assets/jokes.png";

export const ProjectComponent = () => {
  return (
    <section className="w-11/12 mx-auto pb-10 select-none">
      <h1 className="text-5xl mb-10 p-4 lg:p-6 lg:text-6xl rounded-xl w-4/5 lg:w-2/3 mx-auto bg-violet-100 text-violet-900 uppercase text-center">
        Projects
      </h1>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 gap-4">
         {/* Zero CARD */}
         <div className="flex justify-center items-center">
          <div className="p-2 rounded-lg bg-slate-100">
            <div className="group relative block overflow-hidden rounded-md  transition-all duration-500">
              <div className="lightbox transition-all duration-500  group-hover:scale-105 tobii-zoom">
                <img src={recipe} alt="recipe-logo" />
              </div>
              <div className="absolute lg:h-48 2xl:h-44 -bottom-52 group-hover:bottom-2 right-2 left-2 transition-all duration-500  bg-white dark:bg-slate-100 p-4 rounded shadow dark:shadow-gray-700">
                <a
                  href="https://main--rainbow-kataifi-bf97a3.netlify.app/"
                  className="hover:text-primary-600 text-md transition duration-500 font-medium "
                  target="_blank"
                >
                web-app where you can search your favourite recipe in one place.{" "}
                  <div className="bg-violet-600 my-3 w-32 text-center font-normal text-white px-2 py-1 rounded-md hover:bg-slate-800 transition-all">
                    Live Preview
                  </div>
                </a>
                <a
                  href="https://github.com/hashZero1/recipe-app"
                  className="border-2 border-violet-600 text-center font-normal text-violet-800 px-2 py-2 rounded-md hover:bg-violet-600 hover:text-white transition-all"
                  target="_blank"
                >
                  Github Repository
                </a>
              </div>
            </div>
            <div className="mt-2 ml-3 font-semibold text-xl">Recipe App</div>
          </div>
        </div>

        {/* FIRST CARD */}
        <div className="flex justify-center items-center">
          <div className="p-2 rounded-lg bg-slate-100">
            <div className="group relative block overflow-hidden rounded-md  transition-all duration-500">
              <div className="lightbox transition-all duration-500  group-hover:scale-105 tobii-zoom">
                <img src={store} alt="storex-11" />
              </div>
              <div className="absolute lg:h-48 2xl:h-44 -bottom-52 group-hover:bottom-2 right-2 left-2 transition-all duration-500  bg-white dark:bg-slate-100 p-4 rounded shadow dark:shadow-gray-700">
                <a
                  href="https://main--reliable-tartufo-363822.netlify.app/"
                  className="hover:text-primary-600 text-md transition duration-500 font-medium "
                  target="_blank"
                >
                  A storefront for all your products can be found in this one
                  application.{" "}
                  <div className="bg-violet-600 my-3 w-32 text-center font-normal text-white px-2 py-1 rounded-md hover:bg-slate-800 transition-all">
                    Live Preview
                  </div>
                </a>
                <a
                  href="https://github.com/hashZero1/storex11-app"
                  className="border-2 border-violet-600 text-center font-normal text-violet-800 px-2 py-2 rounded-md hover:bg-violet-600 hover:text-white transition-all"
                  target="_blank"
                >
                  Github Repository
                </a>
              </div>
            </div>
            <div className="mt-2 ml-3 font-semibold text-xl">StoreX-11 App</div>
          </div>
        </div>

        {/* SECOND CARD */}
        <div className="flex justify-center items-center">
          <div className="p-2 rounded-lg bg-slate-100">
            <div className=" group relative block overflow-hidden rounded-md  transition-all duration-500">
              <div className="lightbox transition-all duration-500 group-hover:scale-105 tobii-zoom">
                <img src={amazon} alt="storex-11" />
              </div>
              <div className="absolute lg:h-48 2xl:h-44 -bottom-52 group-hover:bottom-2 right-2 left-2 transition-all duration-500 bg-white dark:bg-slate-100 p-4 rounded shadow dark:shadow-gray-700">
                <a
                  href="https://main--elaborate-piroshki-381b0f.netlify.app/"
                  className="hover:text-primary-600 text-md transition duration-500 font-medium "
                  target="_blank"
                >
                  This Amazon Clone is built from scratch that shows the basic
                  structure of an app.{" "}
                  <div className="bg-violet-600 my-3 w-32 text-center font-normal text-white px-2 py-1 rounded-md hover:bg-slate-800 transition-all">
                    Live Preview
                  </div>
                </a>
                <a
                  href="https://github.com/hashZero1/amazon-clone-app"
                  className="border-2 border-violet-600 text-center font-normal text-violet-800 px-2 py-2 rounded-md hover:bg-violet-600 hover:text-white transition-all"
                  target="_blank"
                >
                  Github Repository
                </a>
              </div>
            </div>
            <div className="mt-2 ml-3 font-semibold text-xl">
              AMAZON CLONE APP
            </div>
          </div>
        </div>

        {/* THIRD CARD */}
        <div className="flex justify-center items-center">
          <div className="p-2 rounded-lg bg-slate-100">
            <div className=" group relative block overflow-hidden rounded-md  transition-all duration-500">
              <div className="lightbox transition-all duration-500 group-hover:scale-105 tobii-zoom">
                <img src={movie} alt="storex-11" />
              </div>
              <div className="absolute lg:h-48 2xl:h-44 -bottom-52 group-hover:bottom-2 right-2 left-2 transition-all duration-500 bg-white dark:bg-slate-100 p-4 rounded shadow dark:shadow-gray-700">
                <a
                  href="https://main--warm-pixie-cf7848.netlify.app/"
                  className="hover:text-primary-600 text-md transition duration-500 font-medium "
                  target="_blank"
                >
                  This web application lets you browse details of any TV shows
                  or movies.{" "}
                  <div className="bg-violet-600 my-3 w-32 text-center font-normal text-white px-2 py-1 rounded-md hover:bg-slate-800 transition-all">
                    Live Preview
                  </div>
                </a>
                <a
                  href="https://main--warm-pixie-cf7848.netlify.app/"
                  className="border-2 border-violet-600 text-center font-normal text-violet-800 px-2 py-2 rounded-md hover:bg-violet-600 hover:text-white transition-all"
                  target="_blank"
                >
                  Github Repository
                </a>
              </div>
            </div>
            <div className="mt-2 ml-3 font-semibold text-xl">MOVIESPOT APP</div>
          </div>
        </div>

        {/* FOURTH CARD */}
        <div className="flex justify-center items-center">
          <div className="p-2 rounded-lg bg-slate-100">
            <div className=" group relative block overflow-hidden rounded-md  transition-all duration-500">
              <div className="lightbox transition-all duration-500 group-hover:scale-105 tobii-zoom">
                <img src={weather} alt="storex-11" />
              </div>
              <div className="absolute lg:h-48 2xl:h-44 -bottom-52 group-hover:bottom-2 right-2 left-2 transition-all duration-500 bg-white dark:bg-slate-100 p-4 rounded shadow dark:shadow-gray-700">
                <a
                  href="https://main--willowy-pothos-32859e.netlify.app/"
                  className="hover:text-primary-600 text-md transition duration-500 font-medium "
                  target="_blank"
                >
                  This application uses weather API to show climate conditions.{" "}
                  <div className="bg-violet-600 my-3 w-32 text-center font-normal text-white px-2 py-1 rounded-md hover:bg-slate-800 transition-all">
                    Live Preview
                  </div>
                </a>
                <a
                  href="https://github.com/hashZero1/weather-app"
                  className="border-2 border-violet-600 text-center font-normal text-violet-800 px-2 py-2 rounded-md hover:bg-violet-600 hover:text-white transition-all"
                  target="_blank"
                >
                  Github Repository
                </a>
              </div>
            </div>
            <div className="mt-2 ml-3 font-semibold text-xl">WEATHER APP</div>
          </div>
        </div>

        {/* FIFTH CARD */}
        <div className="flex justify-center items-center">
          <div className="p-2 rounded-lg bg-slate-100">
            <div className=" group relative block overflow-hidden rounded-md  transition-all duration-500">
              <div className="lightbox transition-all duration-500 group-hover:scale-105 tobii-zoom">
                <img src={todos} alt="storex-11" />
              </div>
              <div className="absolute lg:h-48 2xl:h-44 -bottom-52 group-hover:bottom-2 right-2 left-2 transition-all duration-500 bg-white dark:bg-slate-100 p-4 rounded shadow dark:shadow-gray-700">
                <a
                  href="https://stellar-eclair-50b948.netlify.app/"
                  className="hover:text-primary-600 text-md transition duration-500 font-medium "
                  target="_blank"
                >
                  A Todo-List application made with Advanced React Hooks.{" "}
                  <div className="bg-violet-600 my-3 w-32 text-center font-normal text-white px-2 py-1 rounded-md hover:bg-slate-800 transition-all">
                    Live Preview
                  </div>
                </a>
                <a
                  href="https://github.com/hashZero1/reducer-todolist-app"
                  className="border-2 border-violet-600 text-center font-normal text-violet-800 px-2 py-2 rounded-md hover:bg-violet-600 hover:text-white transition-all"
                  target="_blank"
                >
                  Github Repository
                </a>
              </div>
            </div>
            <div className="mt-2 ml-3 font-semibold text-xl">TODO-LIST APP</div>
          </div>
        </div>

        {/* SIXTH CARD */}
        {/* <div className="flex justify-center items-center">
          <div className="p-2 rounded-lg bg-slate-100">
            <div className=" group relative block overflow-hidden rounded-md  transition-all duration-500">
              <div className="lightbox transition-all duration-500 group-hover:scale-105 tobii-zoom">
                <img src={jokes} alt="storex-11" />
              </div>
              <div className="absolute lg:h-48 2xl:h-44 -bottom-52 group-hover:bottom-2 right-2 left-2 transition-all duration-500 bg-white dark:bg-slate-100 p-4 rounded shadow dark:shadow-gray-700">
                <a
                  href="https://main--snazzy-basbousa-a26f2c.netlify.app/"
                  className="hover:text-primary-600 text-md transition duration-500 font-medium "
                  target="_blank"
                >
                  This web application shows you a set of jokes atrandom using
                  Dad Joke API.{" "}
                  <div className="bg-violet-600 my-3 w-32 text-center font-normal text-white px-2 py-1 rounded-md hover:bg-slate-800 transition-all">
                    Live Preview
                  </div>
                </a>
                <a
                  href="https://github.com/hashZero1/random-dadJokes-app"
                  className="border-2 border-violet-600 text-center font-normal text-violet-800 px-2 py-2 rounded-md hover:bg-violet-600 hover:text-white transition-all"
                  target="_blank"
                >
                  Github Repository
                </a>
              </div>
            </div>
            <div className="mt-2 ml-3 font-semibold text-xl">DAD-JOKES APP</div>
          </div>
        </div> */}
      </div>
    </section>
  );
};
